import { useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { authedAtTimestampAtom } from '../../auth/state';
import { useActiveBrand } from '../../components/branding/useActiveBrand';
import { sessionInfoAtom } from '../../state';
import { isSoftBlockResolvedAtom } from '../softBlockResolvedAtom';
import { VisitorState, visitorNameAtom, visitorStateAtom } from '../state';
import { setDefaultWaitingRoomFaviconAndTitle } from '../waiting-room/metadata';

export function useEnterWaitingRoomCallback() {
  const activeBrand = useActiveBrand();
  const setVisitorName = useSetAtom(visitorNameAtom);
  const setVisitorState = useSetAtom(visitorStateAtom);
  const getAuthedAtTimestamp = useAtomCallback(useCallback((get) => get(authedAtTimestampAtom), []));
  const getSoftBlockInfo = useAtomCallback(useCallback((get) => get(sessionInfoAtom)?.softBlock, []));
  const getIsSoftBlockResolved = useAtomCallback(useCallback((get) => get(isSoftBlockResolvedAtom), []));

  return useCallback(
    (visitorName: string) => {
      const isAuthenticated = getAuthedAtTimestamp() !== null;
      const isEligibleForSoftBlock = isAuthenticated && (getSoftBlockInfo()?.isServerEligible ?? false);
      const shouldSoftBlock = isEligibleForSoftBlock && !getIsSoftBlockResolved();

      setVisitorName(visitorName);

      if (shouldSoftBlock) {
        return setVisitorState(VisitorState.PRESESSION_MEASURES);
      }

      setVisitorState(VisitorState.WAITING);
      setDefaultWaitingRoomFaviconAndTitle(activeBrand);
    },
    [activeBrand, setVisitorName, setVisitorState, getAuthedAtTimestamp, getSoftBlockInfo, getIsSoftBlockResolved],
  );
}
